import Status from "../../../../components/Status";
import Button from "../../../../components/Button";
import detailStyles from "../../css/inventoryItemDetail.module.css";
import styles from "../css/expiredStock.module.css";
import { statusColor } from "./ColumnDefinitions";

export default function ClinicModal({ selectedRow, roleId, onPullFromInventory }) {
  return (
    <div className={`${detailStyles.card} ${styles.viewMoreTheme}`}>
      <h2 style={{ marginTop: 0 }}>{selectedRow.drugName}</h2>

      {/* Row 1: Bar Code, SKU Number, Strength, Pack Size, Category */}
      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Bar Code</label>
          <input
            type="text"
            defaultValue={selectedRow.item?.barcode || selectedRow.barcode || ""}
          />
        </div>
        <div className={detailStyles.field}>
          <label>SKU Number</label>
          <input type="text" defaultValue={selectedRow.sku ?? ""} />
        </div>
        <div className={detailStyles.field}>
          <label>Strength</label>
          <input type="text" defaultValue={selectedRow.drug?.strength || ""} />
        </div>
        <div className={detailStyles.field}>
          <label>Pack Size</label>
          <input type="text" defaultValue={selectedRow.packsize || ""} />
        </div>
        <div className={detailStyles.field}>
          <label>Category</label>
          <input
            type="text"
            defaultValue={selectedRow.category || selectedRow.item?.category || ""}
          />
        </div>
      </div>

      {/* Row 2: Price, Bin Number, On Shelf, Expiry Date */}
      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Price</label>
          <input type="text" defaultValue={selectedRow.costprice ?? ""} />
        </div>
        <div className={detailStyles.field}>
          <label>Bin Number</label>
          <input type="text" defaultValue={selectedRow.drug?.binnumber || ""} />
        </div>
        <div className={detailStyles.field}>
          <label>On Shelf</label>
          <input type="text" defaultValue={selectedRow.qty > 0 ? "Yes" : "No"} />
        </div>
        <div
          className={`${detailStyles.field} ${styles.expiryThemed}`}
          style={{"--expiry-color": statusColor(selectedRow.priority)}}
        >
          <label>Expiry Date</label>
          <input type="date" defaultValue={selectedRow.expiry || ""} disabled />
        </div>
      </div>

      {/* Row 3: Quantity, Priority Level, Date Received */}
      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Quantity</label>
          <input type="text" defaultValue={selectedRow.qty} />
        </div>
        <div className={detailStyles.field}>
          <label>Priority Level</label>
          <div>
            <Status status={selectedRow.priority || "High"} variant="priority" />
          </div>
        </div>
        <div className={detailStyles.field}>
          <label>Date Received</label>
          <input type="date" defaultValue={selectedRow.lastReorder || ""} disabled />
        </div>
      </div>

      {/* Row 4: Supplier, Last Reorder */}
      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Supplier</label>
          <input
            type="text"
            defaultValue={selectedRow.suppliername || selectedRow.suppliercode || ""}
          />
        </div>
        <div className={detailStyles.field}>
          <label>Last Reorder</label>
          <input type="date" defaultValue={selectedRow.lastReorder || ""} disabled />
        </div>
      </div>

      {roleId === 4 && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1.5rem",
          }}
        >
          <Button
            type="button"
            variant="secondary"
            onClick={() => onPullFromInventory?.(selectedRow.sku)}
          >
            Pull from inventory
          </Button>
        </div>
      )}
    </div>
  );
}
